export default __webpack_public_path__ + "static/media/arrow.f8c17ab3.svg";